
import React from "react";
import EmptyState from "@/components/EmptyState";
import OfferCard from "@/components/OfferCard";
import type { SellerOffer } from "@/types/offers";

interface SellerOffersProps {
  offers: SellerOffer[];
  sellerName: string;
  sellerId: string;
  averageRating: string;
  reviewCount: number;
  sellerSlug?: string;
}

const SellerOffers = ({ 
  offers, 
  sellerName, 
  sellerId,
  averageRating,
  reviewCount,
  sellerSlug
}: SellerOffersProps) => {
  if (!offers?.length) {
    return (
      <EmptyState 
        title="No Offers Available"
        description="This seller doesn't have any active offers at the moment."
        icon="inbox"
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 xs:grid-cols-1 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
      {offers.map((offer) => (
        <OfferCard 
          key={offer.id}
          id={offer.id}
          title={offer.title}
          price={offer.price_cents / 100}
          dr={offer.dr}
          da={offer.da}
          traffic={offer.traffic_estimate}
          linkType={offer.link_type}
          turnaroundDays={offer.turnaround_days}
          tags={offer.tags || []}
          sellerName={sellerName}
          sellerId={sellerId}
          sellerRating={parseFloat(averageRating)}
          sellerReviewCount={reviewCount}
          slug={offer.slug}
          sellerSlug={sellerSlug}
        />
      ))}
    </div>
  );
};

export default SellerOffers;
